"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationToJSON = exports.ReservationFromJSONTyped = exports.ReservationFromJSON = exports.instanceOfReservation = void 0;
var runtime_1 = require("../runtime");
var CampaignAdProduct_1 = require("./CampaignAdProduct");
var ReservationStatus_1 = require("./ReservationStatus");
/**
 * Check if a given object implements the Reservation interface.
 */
function instanceOfReservation(value) {
    var isInstance = true;
    isInstance = isInstance && "adProduct" in value;
    return isInstance;
}
exports.instanceOfReservation = instanceOfReservation;
function ReservationFromJSON(json) {
    return ReservationFromJSONTyped(json, false);
}
exports.ReservationFromJSON = ReservationFromJSON;
function ReservationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'startDate': !(0, runtime_1.exists)(json, 'start_date') ? undefined : (new Date(json['start_date'])),
        'endDate': !(0, runtime_1.exists)(json, 'end_date') ? undefined : (new Date(json['end_date'])),
        'country': !(0, runtime_1.exists)(json, 'country') ? undefined : json['country'],
        'adProduct': (0, CampaignAdProduct_1.CampaignAdProductFromJSON)(json['ad_product']),
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : (0, ReservationStatus_1.ReservationStatusFromJSON)(json['status']),
        'createdAt': !(0, runtime_1.exists)(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'updatedAt': !(0, runtime_1.exists)(json, 'updated_at') ? undefined : (new Date(json['updated_at'])),
        'adAccountId': !(0, runtime_1.exists)(json, 'ad_account_id') ? undefined : json['ad_account_id'],
        'adSetId': !(0, runtime_1.exists)(json, 'ad_set_id') ? undefined : json['ad_set_id'],
        'version': !(0, runtime_1.exists)(json, 'version') ? undefined : json['version'],
    };
}
exports.ReservationFromJSONTyped = ReservationFromJSONTyped;
function ReservationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'start_date': value.startDate === undefined ? undefined : (value.startDate.toISOString()),
        'end_date': value.endDate === undefined ? undefined : (value.endDate.toISOString()),
        'country': value.country,
        'ad_product': (0, CampaignAdProduct_1.CampaignAdProductToJSON)(value.adProduct),
        'status': (0, ReservationStatus_1.ReservationStatusToJSON)(value.status),
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updated_at': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'ad_account_id': value.adAccountId,
        'ad_set_id': value.adSetId,
        'version': value.version,
    };
}
exports.ReservationToJSON = ReservationToJSON;
